import { Component, OnInit } from '@angular/core';
import { CompanyService } from '../services/company.service';
import { Company } from '../models/Company';
import { Router } from '@angular/router';
import { ActionsComponent } from './actions/actions.component';

@Component({
  selector: 'app-company-data-details',
  templateUrl: './company-data-details.component.html',
  styleUrls: ['./company-data-details.component.scss']
})
export class CompanyDataDetailsComponent implements OnInit {
  public settings = {
    actions: false,
    hideSubHeader: true,
    columns: {
      cui: {
        title: 'CUI'
      },
      name: {
        title: 'Denumire'
      },
      onrcRegistrationNumber: {
        title: 'Nr. Inreg. ONRC'
      },
      creationDate: {
        title: 'Data infiintarii'
      },
      actiuni: {
        title: 'Actiuni',
        type: 'custom',
        renderComponent: ActionsComponent,
        onComponentInitFunction: (instance: any) => {
          instance.edit.subscribe((row: any) => {
            this.onCustomAction({
              data: row,
              action: 'editCompanyDetails'
            });
          });
          instance.view.subscribe((row: any) => {
            this.onCustomAction({
              data: row,
              action: 'viewCompanyDetails'
            });
          });
        }
      }
    },
  };
  public companyDetails: Company;
  public closeResult: string;
  public companies: Company[] = [];

  ngOnInit(): void {
    this.setCompanies();
  }

  constructor(private companyService: CompanyService,
    private router: Router) {
  }

  setCompanies(): void {
    this.companyService.getAllUserCompanies().subscribe((companies: Company[]) => {
      this.companies = companies;
    });
  }

  onCustomAction(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'deleteCompany':
        console.log(event.data.id);
        this.deleteCompany(event.data.id);
        break;
      case 'editCompanyDetails':
        console.log(event.data.id);
        this.router.navigateByUrl('/utilizator/persoana-juridica/date-identificare',
          {
            state: {
              clientId: event.data.clientId, editable: true
            }
          });
        break;
      case 'viewCompanyDetails':
        console.log(event.data.id);
        this.router.navigateByUrl('/utilizator/persoana-juridica/date-identificare',
          {
            state: {
              clientId: event.data.clientId, editable: false
            }
          });
        break;
    }
  }

  deleteCompany(companyId: number): void {
    this.companyService.deleteCompany(companyId).subscribe(() => {
      this.setCompanies();
    });
  }

  openCreationForm(): void {
    this.router.navigateByUrl('/utilizator/persoana-juridica/date-identificare',
      {
        state: { clientId: null, editable: true }
      });
  }
}
